
<div class="add-product-spaces-popoup wt-block">
    <p-dialog [(visible)]="_project.isdisplayTagSpaces" [showHeader]="false"  [modal]="true" 
      [baseZIndex]="100000" [transitionOptions]="_pop.dialogTransitionTime" [dismissableMask]="_pop.closeOutside">
      <div class="space-loader-img" *ngIf="_sis.isLoadSpace">
        <div class="mountroot">
          <div class="loader-container">
            <div class="spinner-spinner">
  
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!_sis.isLoadSpace">
        <div class="add-product-popup-body">
          <div class="close-add-space">
            <img src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg" alt="close">
          </div>
          <div class="add-product-popup-heading">
            <div>
              <h3 *ngIf="_sis.product_add_action !=='addToCart'">
                <img src="https://res.cloudinary.com/afterbricks/image/upload/v1685433709/heart_1_h5rut5.png" alt="">
                Save idea to collection</h3>
              <h3 *ngIf="_sis.product_add_action ==='addToCart'">Add To cart</h3>
              <div class="row all-space-add-space">
                <div class="tag-all-space-strip">
                  <!-- <p>Click this button to save this idea for </p> -->
                  <p>You like it for which all spaces?</p>
                  <div class="position-relative">
                    <p-checkbox label="All Spaces" [(ngModel)]="_sis.main_space_select_all_flag"
                    value="main_space_select_all_flag" (onChange)="_sis.onSelecteAllSpace(_sis.main_space_select_all_flag)"
                    [binary]="true" [ngClass]="{'MMainSubCateGoryActive':_sis.main_space_select_all_flag}">
                  </p-checkbox>
                  

                <div  class="checked-svg" [ngClass]="{'active-checked-svg':_sis.main_space_select_all_flag}">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <circle cx="7" cy="7" r="7" fill="#1A374D" />
                      <path
                          d="M6.0003 8.0001L4.0001 5.9999L3 7L6.0003 10.0003L11.0008 4.9998L10.0007 3.9997L6.0003 8.0001Z"
                          fill="white" />
                  </svg>
              </div>
                  </div>
                  
                </div>
              </div>
            </div>
            <div class="add-product-spaces-popoup-product p-0">
              <div class="active-product-card">
                <img [src]="_sis.tagged_product?.image_list[0].image" [alt]="_sis.tagged_product?.name">
              </div>
              <p class="brand-name">{{_sis.tagged_product?.brand_name}}</p>
            </div>
          </div>
          <div class="add-product-spaces-popoup-body">
            <!-- """"""""""""""""""""""" Space Container "'""""""""""""""""""""""""""""-->
            <div class="add-product-spaces-popoup-space">
              <div class="row">
                <div class=" datacheckboxing">
                  <p-scrollPanel styleClass="spaces-scroller">
                    <div class="row space-list" *ngFor="let ms of _project.main_space_list; let msi=index">
                      <div class="col-12 row pl-3">
                        <p class="p-100-px main-space-name" style="color: #004299;">
                          <img [src]="ms?.sub_space_list[0]?.icon" [alt]="ms?.name">{{ms?.name}} <button class="add-more-btn"
                            (click)="_sis.redirectToSelectSpace(_sis.activeProd,_sis.activePos,ms?.mId)">
                            <i class="fa fa-pencil" aria-hidden="true"></i> Edit spaces</button>
                        </p>
  
                        <div class="d-flex sub-space-popup">
                          <div class="main-space-popup" *ngIf="ms.sub_space_list.length > 1">
                            <p-checkbox label="All" [(ngModel)]="ms.is_selected" value="ms.is_selected" [binary]="true"
                              (onChange)="_sis.onTagAllSubSpace(ms.is_selected,msi)"
                              [ngClass]="{'MMainSubCateGoryActive':ms.is_selected}" *ngIf="ms.sub_space_list.length > 1">
                            </p-checkbox>
                            <div  class="checked-svg"  [ngClass]="{'active-checked-svg':ms.is_selected}">
                              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="7" cy="7" r="7" fill="#1A374D" />
                                <path
                                  d="M6.0003 8.0001L4.0001 5.9999L3 7L6.0003 10.0003L11.0008 4.9998L10.0007 3.9997L6.0003 8.0001Z"
                                  fill="white" />
                              </svg>
                            </div>
                          </div>
                          <div class="position-relative" *ngFor="let ss of ms.sub_space_list;let ssi=index">
                          
  

                            <div class="check-box-card" [ngClass]="{'active-check-box-card':ss.is_selected}">
                              <input type="checkbox" [(ngModel)]="ss.is_selected"
                                  (change)="_sis.onAddProductToSpace(ss.id,ss.is_selected,msi,ssi)" [value]="ss.is_selected"
                                  [id]="ss.id" />
                              <label [for]="ss?.id">
                                <span>
                                  {{ss.name}}
                                </span>
                                <div class="added-btn" *ngIf="ss.tagged_products.length" (mouseover)="_sis.onHoverSpace(ss.id)"
                                  (mouseleave)="_sis.onHoverSpace(undefined)">
                                  <div class="products-in-space"
                                    [ngClass]="{'activer-pis':ss.id===_sis.activerSpaceID,'products-in-space-more-then-3':ss.tagged_products.length > 3}">
                                    <div *ngFor="let sp of ss.tagged_products;let spi=index;">
                                      <div class="product-spi-list">
                                        <div class="product-spi-image"
                                          [ngClass]="{'current-product-spi-image':sp.id === _sis.temp_product_id}">
                                          <img [src]="sp?.image_list[0]?.image_url" [alt]="sp?.name">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- *ngIf="ss.is_selected" -->
                                <div class="checked-svg" [ngClass]="{'active-checked-svg':ss.is_selected}" >
                                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="7" cy="7" r="7" fill="#1A374D" />
                                    <path
                                      d="M6.0003 8.0001L4.0001 5.9999L3 7L6.0003 10.0003L11.0008 4.9998L10.0007 3.9997L6.0003 8.0001Z"
                                      fill="white" />
                                  </svg>
                                </div>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </p-scrollPanel>
                </div>
              </div>
            </div>
            <!-- """"""""""""""""""""""" End space Container "'""""""""""""""""""""""""""""-->
          </div>
  
  
        </div>
        <div class="add-product-spaces-popoup-footer">
          <p> <a class="collection-btn" (click)="_sis.space_review()">See Collection</a>  {{_sis.currentSubCategoryName}} </p>
          <button class="btn btn-light cancel-bttn" (click)="_sis.oncloseAddPro(true)"
            *ngIf="!_sis.tagged_in_spaces_count">Cancel</button>
          <button class="btn done-btn popup-save-btn" (click)="_sis.oncloseAddPro(true)" *ngIf="_sis.tagged_in_spaces_count">
            <i *ngIf="_sis.isCloseAddSpace" style="font-size: 15px;" class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
            <!-- <svg width="18" height="17" viewBox="0 0 19 17" fill="none" style=" margin-right: 8px;"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.39332 16.5C9.39332 16.5 0.000123926 12.6923 0.000123926 5.75C-0.0192346 2.84609 2.23191 0.5 5.00724 0.5C6.96736 0.5 8.67525 1.69241 9.49036 3.42311C10.3055 1.69241 12.0134 0.5 13.9735 0.5C16.7488 0.5 19 2.84615 19 5.75C19 12.6538 9.39332 16.5 9.39332 16.5Z"
                fill="#fc9918" />
            </svg> -->
            Save idea
          </button>
        </div>
        <div class="save-idea-sub-bg" >
          <img src="assets/images/bg/save-idea--popup-bg.jpg" title="Save idea">
      </div>
      </div>
    </p-dialog>
  </div>
  
  <!-- spaces on mobile pop up -->
  
  <div class="add-product-spaces-popoup m-block" *ngIf="_as.isOnMobilePlatform">
  
    <p-sidebar [(visible)]="_project.isdisplayTagSpaces" position="bottom"  [transitionOptions]="_pop.dialogTransitionTime"  [baseZIndex]="10000" [showCloseIcon]="false"
      [blockScroll]="true">
      <div class="add-product-popup-body">
  
        <div class="close-add-space" (click)="_sis.oncloseAddPro(true)">
          <img src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg" alt="close">
        </div>
        <div class="add-product-popup-heading">
          <div>
            <h3 *ngIf="_sis.product_add_action !=='addToCart'">
              <img src="https://res.cloudinary.com/afterbricks/image/upload/v1685433709/heart_1_h5rut5.png" alt="Save idea to collection">
              Save idea to collection</h3>
            <h3 *ngIf="_sis.product_add_action ==='addToCart'">Add To cart</h3>
            <div class="row all-space-add-space">
              <div class="tag-all-space-strip">
                <!-- <p>Click this button to save this idea for </p> -->
                <p>You like it for which all spaces?</p>
                <div class="d-flex align-items-center position-relative">
                  <p-checkbox label="All Spaces" [(ngModel)]="_sis.main_space_select_all_flag"
                    value="main_space_select_all_flag" (onChange)="_sis.onSelecteAllSpace(_sis.main_space_select_all_flag)"
                    [binary]="true" [ngClass]="{'MMainSubCateGoryActive':_sis.main_space_select_all_flag}" [disabled]="_sis.isSelectProduct">
                  </p-checkbox>
                  <div *ngIf="_sis.main_space_select_all_flag" class="checked-svg">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <circle cx="7" cy="7" r="7" fill="#1A374D" />
                        <path
                            d="M6.0003 8.0001L4.0001 5.9999L3 7L6.0003 10.0003L11.0008 4.9998L10.0007 3.9997L6.0003 8.0001Z"
                            fill="white" />
                    </svg>
                </div>
                </div>
              </div>
            </div>
          </div>
  
        </div>
        <div class="add-product-spaces-popoup-product p-0">
          <div class="active-product-card">
            <img [src]="_sis.tagged_product?.image_list[0].image" [alt]="_sis.tagged_product?.name">
          </div>
          <p class="brand-name">{{_sis.tagged_product?.brand_name}}</p>
        </div>
        <div class="add-product-spaces-popoup-body" [ngClass]="{'on-change-opacity':_sis.isSelectProduct}">
  
  
          <!-- """"""""""""""""""""""" Space Container "'""""""""""""""""""""""""""""-->
          <div class="add-product-spaces-popoup-space">
            <div class="row">
              <div class=" datacheckboxing">
                <p-scrollPanel styleClass="spaces-scroller">
                  <div class="row space-list" *ngFor="let ms of _project.main_space_list; let msi=index">
                    <div class="col-12 row px-0 ">
                      <p class="p-100-px main-space-name" style="color: #004299;">
                        <img [src]="ms.sub_space_list[0].icon" [alt]="ms.name"> {{ms.name}} <button class="add-more-btn"
                          (click)="_sis.redirectToSelectSpace(_sis.activeProd,_sis.activePos,ms?.mId)"><i class="fa fa-pencil" aria-hidden="true"></i> Edit spaces</button>
                      </p>
                      <div class="d-flex sub-space-popup">
                        <div class="main-space-popup" *ngIf="ms.sub_space_list.length > 1">
                          <p-checkbox label="All" [(ngModel)]="ms.is_selected" value="ms.is_selected" [binary]="true"
                            (onChange)="_sis.onTagAllSubSpace(ms.is_selected,msi)"
                            [ngClass]="{'MMainSubCateGoryActive':ms.is_selected}" *ngIf="ms.sub_space_list.length > 1" [disabled]="_sis.isSelectProduct">
                          </p-checkbox>
                          <div *ngIf="ms.is_selected" class="checked-svg">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="7" cy="7" r="7" fill="#1A374D" />
                              <path
                                d="M6.0003 8.0001L4.0001 5.9999L3 7L6.0003 10.0003L11.0008 4.9998L10.0007 3.9997L6.0003 8.0001Z"
                                fill="white" />
                            </svg>
                          </div>
                        </div>
                        <div class="position-relative" *ngFor="let ss of ms.sub_space_list;let ssi=index">
                          <div class="check-box-card" [ngClass]="{'active-check-box-card':ss.is_selected}">
                            <input type="checkbox" [(ngModel)]="ss.is_selected"
                            (change)="_sis.onAddProductToSpace(ss.id,ss.is_selected,msi,ssi)" [value]="ss.is_selected"
                            [id]="ss.id" />
                            <label [for]="ss?.id">
                              <span>
                                {{ss.name}}
                              </span>
                              <div class="added-btn" *ngIf="ss.tagged_products.length" (mouseover)="_sis.onHoverSpace(ss.id)"
                                (mouseleave)="_sis.onHoverSpace(undefined)">
                                <div class="products-in-space"
                                  [ngClass]="{'activer-pis':ss.id===_sis.activerSpaceID,'products-in-space-more-then-3':ss.tagged_products.length > 3}">
                                  <div *ngFor="let sp of ss.tagged_products;let spi=index;">
                                    <div class="product-spi-list">
                                      <div class="product-spi-image"
                                        [ngClass]="{'current-product-spi-image':sp.id === _sis.temp_product_id}">
                                        <img [src]="sp.image_list[0].image" [alt]="sp.name">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              
                              <div class="checked-svg" *ngIf="ss.is_selected">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="7" cy="7" r="7" fill="#1A374D" />
                                  <path
                                    d="M6.0003 8.0001L4.0001 5.9999L3 7L6.0003 10.0003L11.0008 4.9998L10.0007 3.9997L6.0003 8.0001Z"
                                    fill="white" />
                                </svg>
                              </div>
  
                            </label>
                          </div>
  
                        </div>
                      </div>
                    </div>
                  </div>
                </p-scrollPanel>
              </div>
            </div>
          </div>
          <!-- """"""""""""""""""""""" End space Container "'""""""""""""""""""""""""""""-->
        </div>
      </div>
  
      <div class="add-product-spaces-popoup-footer" [ngClass]="{'on-change-opacity':_sis.isSelectProduct}">
        <a class="collection-btn" (click)="_sis.space_review()" title="See Collection">See Collection</a>
        <button class="btn btn-light cancel-bttn" (click)="_sis.oncloseAddPro(true)"
          *ngIf="!_sis.tagged_in_spaces_count">Cancel</button>
          
        <button class="btn done-btn hover done-btn-mob" (click)="_sis.oncloseAddPro(true)" *ngIf="_sis.tagged_in_spaces_count">
          <i *ngIf="_sis.isCloseAddSpace" style="font-size: 15px;" class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
          <!-- <svg width="17" height="18" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg"
            style="margin-right: 6px;">
            <path
              d="M9.39332 16.5C9.39332 16.5 0.000123926 12.6923 0.000123926 5.75C-0.0192346 2.84609 2.23191 0.5 5.00724 0.5C6.96736 0.5 8.67525 1.69241 9.49036 3.42311C10.3055 1.69241 12.0134 0.5 13.9735 0.5C16.7488 0.5 19 2.84615 19 5.75C19 12.6538 9.39332 16.5 9.39332 16.5Z"
              fill="#fc9918" />
          </svg> -->
          SAVE IDEA
        </button>
      </div>
      <div class="save-idea-sub-bg" >
        <img src="assets/images/bg/save-idea--popup-bg.jpg">
    </div>
    </p-sidebar>
  </div>